import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function Blog() {
  const navigate = useNavigate();
  const [articles, setArticles] = useState([]);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('Toutes');
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  const categories = [
    'Toutes',
    'Le Marketing de réseau et le NetWorking',
    'Les outils pour bien démarrer',
    'Découvrir les nouveaux MLM'
  ];

  useEffect(() => {
    fetchArticles();
  }, []);

  useEffect(() => {
    filterArticles();
  }, [articles, selectedCategory, searchTerm]);

  const fetchArticles = async () => {
    try {
      const response = await axios.get(`${API}/articles`);
      setArticles(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching articles:', error);
      setLoading(false);
    }
  };

  const filterArticles = () => {
    let filtered = articles;

    if (selectedCategory !== 'Toutes') {
      filtered = filtered.filter(article => article.category === selectedCategory);
    }

    if (searchTerm) {
      filtered = filtered.filter(article =>
        article.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        article.excerpt.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredArticles(filtered);
  };

  return (
    <div className="app">
      <nav className="nav">
        <div className="nav-container">
          <div className="nav-logo" onClick={() => navigate('/')} style={{cursor: 'pointer'}}>
            <span className="logo-text">AmsWeb</span>
            <span className="logo-subtitle">Aide MultiServices du Web</span>
          </div>
          <div className="nav-links">
            <a href="/" className="nav-link">Accueil</a>
            <a href="/formations-outils" className="nav-link">Formations</a>
            <a href="/blog" className="nav-link">Blog</a>
            <a href="/#contact" className="nav-link nav-cta">Contact</a>
          </div>
        </div>
      </nav>

      <section className="blog-hero">
        <div className="container">
          <h1 className="blog-hero-title">📝 Le Blog AmsWeb</h1>
          <p className="blog-hero-subtitle">
            Toutes les astuces et innovations pour être au Top sur le Net<br />
            et développer ton activité MLM avec succès
          </p>
        </div>
      </section>

      <section className="blog-filters-section">
        <div className="container">
          <div className="blog-filters">
            <div className="search-box">
              <input
                type="text"
                placeholder="🔍 Rechercher un article..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
                data-testid="blog-search"
              />
            </div>
            <div className="category-filters">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="blog-articles-section">
        <div className="container">
          {loading ? (
            <div className="loading-state">
              <p>Chargement des articles...</p>
            </div>
          ) : filteredArticles.length === 0 ? (
            <div className="empty-state">
              <p>😕 Aucun article trouvé pour cette recherche.</p>
            </div>
          ) : (
            <>
              <div className="articles-count">
                <p>{filteredArticles.length} article{filteredArticles.length > 1 ? 's' : ''} trouvé{filteredArticles.length > 1 ? 's' : ''}</p>
              </div>
              <div className="blog-articles-grid">
                {filteredArticles.map((article) => (
                  <div
                    key={article.id}
                    className="article-card"
                    onClick={() => navigate(`/blog/${article.slug}`)}
                  >
                    <div className="article-card-image">
                      <img src={article.image_url} alt={article.title} loading="lazy" />
                      <div className="article-card-category">{article.category}</div>
                    </div>
                    <div className="article-card-content">
                      <h3>{article.title}</h3>
                      <p>{article.excerpt}</p>
                      <div className="article-card-footer">
                        <span className="read-more">Lire l'article →</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </section>

      <section className="blog-cta-section">
        <div className="container">
          <div className="blog-cta-content">
            <h2>💪 Prêt à Passer à l'Action ?</h2>
            <p>
              Tu as lu nos articles, maintenant découvre nos formations<br />
              pour développer concrètement ton activité MLM
            </p>
            <button
              onClick={() => navigate('/formations-outils')}
              className="btn btn-primary btn-large"
            >
              Découvrir Nos Formations 🚀
            </button>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>AmsWeb</h3>
              <p>Aide MultiServices du Web</p>
              <p className="footer-tagline">Toutes les astuces pour développer ton MLM</p>
            </div>
            <div className="footer-section">
              <h4>Navigation</h4>
              <ul className="footer-links">
                <li><a href="/">Accueil</a></li>
                <li><a href="/formations-outils">Formations</a></li>
                <li><a href="/blog">Blog</a></li>
                <li><a href="/#contact">Contact</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Contact</h4>
              <p>✉️ <a href="mailto:contact@amsweb.fr">contact@amsweb.fr</a></p>
              <p className="footer-fred">Avec Fred d'AmsWeb</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 AmsWeb.fr - Tous droits réservés</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Blog;